import { camelize } from '@ember/string';
import { filterSystemAndCurrentUser, matchingUsers } from './user';

export const findConversationByContacts = function (conversations, contacts) {
  return conversations.find(conversation => conversationHasExactContacts(conversation, contacts));
};

export const conversationHasExactContacts = function (conversation, contacts) {
  const lengthMatch = conversation.users.length === contacts.length + 1; // +1 for current user
  return (
    lengthMatch &&
    contacts.every(contact => conversation.users.find(u => matchingUsers(u, contact)))
  );
};

export const buildContacts = function (conversation, currentProfile) {
  return filterSystemAndCurrentUser(conversation.users, currentProfile?.user).map(user => {
    return {
      type: 'contacts',
      attributes: {
        'external_id': user.externalId,
        'external_scope': user.externalScope,
        'organization_id': user.organizationId,
        'name': user.name,
      },
    };
  });
};

export async function getInactiveReasonsFromResponse(response) {
  const json = await response.json();
  const error = json.errors?.[0];
  return error?.meta ? camelizeMeta(error?.meta) : fallbackInactiveReason(error?.title);
}

export const conversationUserNames = function (names) {
  if (names.length <= 1) return names[0] ?? '';
  if (names.length === 2) return names.join(' & ');
  return `${names.slice(0, -1).join(', ')} & ${names[names.length - 1]}`;
};

export const firstNameAndLastNameInitial = function (name) {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 1) return parts[0];
  const lastPart = parts[parts.length - 1];
  const firstChar = Array.from(lastPart)[0];
  return firstChar ? `${parts[0]} ${firstChar}.` : `${parts[0]}.`;
};

function fallbackInactiveReason(title) {
  return [{ message: title || 'Unknown error' }];
}

function camelizeMeta(inactiveReasons) {
  return inactiveReasons.map(inactiveReason => {
    if (!inactiveReason.meta) return inactiveReason;
    const camelizedMeta = Object.entries(inactiveReason.meta).reduce((acc, [key, value]) => {
      return {
        ...acc,
        ...{ [camelize(key)]: value },
      };
    }, {});
    return { ...inactiveReason, meta: camelizedMeta };
  });
}

const compareByName = (a, b) => (a.name ?? '').localeCompare(b.name ?? '');

const memberTier = (user, currentUser) => {
  if (currentUser && matchingUsers(user, currentUser)) {
    return 0;
  }

  return user.isClient ? 1 : 2;
};

export const sortConversationMembers = function (users, currentUser) {
  return [...users].sort((a, b) => {
    const tierDiff = memberTier(a, currentUser) - memberTier(b, currentUser);
    return tierDiff || compareByName(a, b);
  });
};
